import { groupifyUrl } from "./groupifyUrl";
import DatadogLogger from "@lib/datadogLogger";
import type { DataDogLoggerShape } from "./types";

export const logToDataDog = ({
  actionName,
  url,
  loadDuration,
  errorText,
  estimated = true,
}: DataDogLoggerShape) => {
  DatadogLogger.userAction(actionName, {
    url,
    groupUrl: groupifyUrl(url),
    loadDuration,
    statusText: errorText || "ok",
    estimated,
  });
};
